/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OptimizationSummary {
    getFixupPrototypeFunction() { return OptimizationSummary.fixupPrototype; }

    static newInstance(model: Partial<OptimizationSummary>): OptimizationSummary {
        let obj = Object.assign(new OptimizationSummary(), model);
        OptimizationSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OptimizationSummary>): OptimizationSummary {
        if (!model) return null;
        return OptimizationSummary.newInstance(<OptimizationSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OptimizationSummary) {
        if (!obj) return;

        models.OptimizationSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OptimizationSummary): boolean {
        Object.setPrototypeOf(obj, OptimizationSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.estimated_cost === undefined) {
            this.estimated_cost = 0;
        }
    }

    /**
     * Total Cost
     */
    total_cost: any;

    /**
     * Total Count
     */
    recommendations: any;

    /**
     * Saving Percentage
     */
    savings_percentage: string;

    /**
     * Information
     */
    info: string;

    /**
     * forecasted cost
     */
    estimated_cost: number;

    /**
     * Impacted resources
     */
    impacted_resources: any;

}
